module.exports = __webpack_public_path__ + "img/electric_no_zone.34ca5e7f.svg";